import { createBaseThemeVariation } from './base';
export const BrightHorizonsTheme = createBaseThemeVariation({
    name: 'brighthorizons',
    brandColor: 'hsla(198, 45%, 20%, 1)',
    primaryColors: {
        p50: 'hsla(198, 45%, 98%, 1)',
        p75: 'hsla(198, 45%, 97%, 1)',
        p100: 'hsla(198, 45%, 96%, 1)',
        p200: 'hsla(198, 45%, 90%, 1)',
        p300: 'hsla(198, 45%, 70%, 1)',
        p400: 'hsla(198, 45%, 20%, 1)',
        p500: 'hsla(198, 45%, 10%, 1)',
    },
});
